<template>
  <v-dialog
    v-model="showModal"
    :persistent="loading"
    max-width="80%"
    class="pa-2"
  >
    <v-card>
      <modal-bar title="contactos del cliente" @onClose="showModal = false" />
      <template v-if="loading">
        <v-skeleton-loader boilerplate type="table" class="mx-4 my-2" />
      </template>
      <div v-else class="pa-4">
        <h1>Contactos del cliente</h1>
        <v-divider />
        <p class="text-left">{{ customerSelected?.name }}</p>

        <v-simple-table dense class="main-table w-100">
          <template #default>
            <thead class="table-heading">
              <tr class="font-weight-bold">
                <th
                  v-for="(header, index) in headers"
                  :key="index"
                  class="text-center text-dark font-weight-bold"
                >
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="index">
                <td
                  v-for="(item, index) in headers"
                  :key="index"
                  class="text-nowrap"
                >
                  <template v-if="item.value === 'phone'">
                    <a
                      v-if="row[item.value]"
                      :href="`tel:${row[item.value]}`"
                      class="text-decoration-none"
                    >
                      <v-icon color="orange">mdi-phone</v-icon>
                      {{ formatPhone(row[item.value]) }}
                    </a>
                  </template>
                  <template v-else> {{ row[item.value] }} </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import dates from '@/mixins/dates';
  import helpers from '@/mixins/helpers';
  import ModalBar from '@/components/modals/ModalBar.vue';

  export default {
    name: 'CustomerContacts',
    components: {
      ModalBar,
    },
    mixins: [dates, helpers],
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
      activeUsername: {
        type: String,
        required: true,
      },
      customerSelected: {
        type: Object,
        required: true,
      },
      headers: {
        type: Array,
        default: () => [
          { text: 'Nombre', value: 'full_name' },
          { text: 'Teléfono', value: 'phone' },
          { text: 'Correo electrónico', value: 'email' },
          { text: 'Puesto', value: 'job_title' },
          { text: 'Dirección', value: 'fiscal_address' },
        ],
      },
    },

    computed: {
      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
